import "./track.css";

/** The logo path scaled ×10. Drawn on a 560×420 canvas to leave room for labels. */
const LOOP_PATH =
  "M60 130 V240 C60 330 130 370 190 330 C250 290 270 190 340 170 C410 150 460 210 460 270 C460 340 390 370 330 340 C280 310 250 250 200 230";

type Stage = {
  num: string;
  name: string;
  /** Station position on the track. */
  x: number;
  y: number;
  /** Label anchor point + alignment. */
  lx: number;
  ly: number;
  anchor: "start" | "middle" | "end";
  /** "launch" = white station with coral ring; "grow" = coral station. */
  kind?: "launch" | "grow";
};

const STAGES: Stage[] = [
  { num: "01", name: "Plan", x: 60, y: 165, lx: 94, ly: 171, anchor: "start" },
  // Points below are exact positions on the curve (Design = lowest point of
  // the left loop; Build sits clear of where the loop crosses itself).
  { num: "02", name: "Design", x: 144, y: 346, lx: 144, ly: 400, anchor: "middle" },
  { num: "03", name: "Build", x: 296, y: 198, lx: 278, ly: 172, anchor: "end" },
  { num: "04", name: "Test", x: 364, y: 166, lx: 380, ly: 132, anchor: "middle" },
  { num: "05", name: "Launch", x: 460, y: 270, lx: 488, ly: 276, anchor: "start", kind: "launch" },
  { num: "06", name: "Grow ↺", x: 330, y: 340, lx: 330, ly: 394, anchor: "middle", kind: "grow" },
];

/**
 * The i∞ logo drawn large as a track straight on the page (no panel), with the
 * six project stages as stations along it and a coral dot travelling the loop.
 * Used on the Home hero.
 */
const HeroLoop = () => (
  <figure className="is-hero-loop">
    <svg
      viewBox="0 0 560 420"
      width="100%"
      role="img"
      aria-label="The Infinitude loop: plan, design, build, test, launch and grow, on repeat"
    >
      <path d={LOOP_PATH} className="is-hero-loop__track" />
      <path d={LOOP_PATH} className="is-hero-loop__centre" />
      <circle cx="60" cy="62" r="26" className="is-hero-loop__i-dot" />

      {STAGES.map((s) => (
        <circle
          key={s.name}
          cx={s.x}
          cy={s.y}
          r={s.kind ? 10 : 9}
          className={"is-hero-loop__station" + (s.kind ? ` is-hero-loop__station--${s.kind}` : "")}
        />
      ))}

      <circle r="9" className="is-hero-loop__runner">
        <animateMotion dur="7s" repeatCount="indefinite" path={LOOP_PATH} />
      </circle>

      {STAGES.map((s) => (
        <text key={s.name} x={s.lx} y={s.ly} textAnchor={s.anchor} className="is-hero-loop__label">
          <tspan
            className={"is-hero-loop__num" + (s.kind === "grow" ? " is-hero-loop__num--accent" : "")}
          >
            {s.num}
          </tspan>{" "}
          {s.name}
        </text>
      ))}
    </svg>
    <figcaption className="is-hero-loop__caption">The infinite loop — always shipping</figcaption>
  </figure>
);

export default HeroLoop;
